import type { QuizBuilderQuestionSchema } from '@repo/schemas/quiz/quizBuilderQuestion';

import { QuestionType } from '@repo/types/enums/questionType';
import { v4 as uuidv4 } from 'uuid';

export const getQuestionDefaultValues = (type: QuestionType): QuizBuilderQuestionSchema => {
  switch (type) {
    case QuestionType.SINGLE:
      return {
        id: uuidv4(),
        type: QuestionType.SINGLE,
        content: '',
        points: 1,
        answers: [
          {
            content: 'Odpowiedź 1',
            correct: true,
            id: uuidv4(),
            explanation: undefined,
          },
          {
            content: 'Odpowiedź 2',
            correct: false,
            id: uuidv4(),
            explanation: undefined,
          },
        ],
      };
    case QuestionType.MULTIPLE:
      return {
        id: uuidv4(),
        type: QuestionType.MULTIPLE,
        content: '',
        points: 1,
        answers: [
          { content: 'Odpowiedź 1', correct: true, id: uuidv4(), points: 1 },
          {
            content: 'Odpowiedź 2',
            correct: false,
            id: uuidv4(),
            points: undefined,
            explanation: undefined,
          },
        ],
      };
    case QuestionType.FILL:
      return {
        id: uuidv4(),
        type: QuestionType.FILL,
        content: '',
        gapsContent: 'Wypełnij luki [luka 1]',
        points: 1,
        gaps: [
          {
            id: 'gap1',
            points: 1,
            options: [
              {
                id: uuidv4(),
                content: 'opcja 1',
                correct: true,
                explanation: undefined,
              },
              {
                id: uuidv4(),
                content: 'opcja 2',
                correct: false,
                explanation: undefined,
              },
            ],
          },
        ],
      };
    case QuestionType.MATCHING:
      return {
        id: uuidv4(),
        type: QuestionType.MATCHING,
        content: '',
        points: 1,
        answers: [
          {
            left: {
              id: uuidv4(),
              content: 'right',
            },
            right: {
              id: uuidv4(),
              content: 'prawo',
            },
            points: 1,
            explanation: undefined,
          },
          {
            left: {
              id: uuidv4(),
              content: 'left',
            },
            right: {
              id: uuidv4(),
              content: 'lewo',
            },
            points: 1,
            explanation: undefined,
          },
        ],
      };
    case QuestionType.TRANSLATE:
      return {
        id: uuidv4(),
        type: QuestionType.TRANSLATE,
        content: '',
        points: 1,
        answers: [],
        options: [
          { id: 1, content: 'Odpowiedź 1' },
          { id: 2, content: 'Odpowiedź 2' },
        ],
      };
    case QuestionType.VOICE:
      return {
        id: uuidv4(),
        type: QuestionType.VOICE,
        content: '',
        points: 1,
        manualCheck: true,
      };
    case QuestionType.LONG:
      return {
        id: uuidv4(),
        type: QuestionType.LONG,
        content: '',
        points: 1,
      };
    default:
      return {
        id: uuidv4(),
        type: QuestionType.SINGLE,
        content: '',
        points: 1,
        answers: [
          {
            content: 'Odpowiedź 1',
            correct: true,
            id: uuidv4(),
            explanation: undefined,
          },
          {
            content: 'Odpowiedź 2',
            correct: false,
            id: uuidv4(),
            explanation: undefined,
          },
        ],
      };
  }
};
